var App = App || {};

App.EstateEstimator = (function ($) {
    'use strict';

    const USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    function init() {

        $('.component-estate-estimator').each(function () {
            var $assets = $(this).find('.asset');
            var $liabilities = $(this).find('.liability');
            var $totalAssets = $('#totalAssets');
            var $totalLiabilities = $('#totalLiabilities');

            $assets.on('change', function () {
                var assetTotal = getTotals($assets);
                var liabilityTotal = getTotals($liabilities);
                $totalAssets.html(USDollar.format(assetTotal));
                calculateNetEstate(assetTotal, liabilityTotal);
            });

            $liabilities.on('change', function () {
                var assetTotal = getTotals($assets);
                var liabilityTotal = getTotals($liabilities);
                $totalLiabilities.html(USDollar.format(liabilityTotal));
                calculateNetEstate(assetTotal, liabilityTotal);
            });

        });
    }

    function calculateNetEstate(assetTotal, liabilityTotal) {
        $('#netEstate').html(USDollar.format(assetTotal - liabilityTotal));
    }

    function getTotals($items) {
        var total = 0;

        $items.each(function () {
            total += $(this).val() * 1;
        });

        return total;
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.EstateEstimator.init();
});